import { MouseEventHandler, ReactElement } from 'react'
import { Variants } from 'motion/react'
import { ProductType } from '@mindfulchefuk/query'
import { LinkProps } from 'next/link'
import { ProductContent } from '@mindfulchefuk/features/Products/interfaces'

export enum CartItemType {
  RECIPE = 'recipe',
  PRODUCT = 'product',
}

export interface RecipeCartItem {
  id: string
  portions: number
  quantity: number
}

export interface RecipeCartState {
  allPortionSelectedRecipes: RecipeCartItem[]
  initialRecipes: RecipeCartItem[]
  lastAddedRecipeId: string
}

export interface ProductCartState {
  selectedProducts: ProductContent[]
  initialProducts: ProductContent[]
  lastAddedProductId: string
}

export interface CartDrawerState {
  isOpen: boolean
}

export interface CartItem {
  hideImagesOnMobile?: boolean
  price?: number
  priceBeforeDiscount?: number
  heading: string
  id: string
  image: string
  quantity?: number
  children?: ReactElement
  as?: string | ReactElement
  isDisabled?: boolean
  url?: LinkProps['href']
  onClick?: MouseEventHandler
  feedback?: {
    id: string
    rating: number
  }
  type?: ProductType

  //Animation properties
  custom?: { index: number }
  layout?: boolean
  variants?: Variants
  initial?: string
  animate?: string
  exit?: string
}
